<template>
  <div id="login">
    <section class="px-lg-0 bannerhome">
      <div class="">
        <div
          class="row no-gutters text-center d-flex justify-content-center align-items-center"
        >
          <div
            class="col-lg-6"
            data-aos="fade-right"
            :data-aos-delay="basedelay + 200"
          >
            <img
              src="../assets/imgs/sorteocch/bg-cchsorteo-2026-mobile-2.jpg"
              alt="Cemento Chihuahua"
              class="w-100 d-block d-lg-none"
            />
          </div>
          <!-- 
          <img
            src="../assets/imgs/playasol/linea-hor2.png"
            alt="linea"
            class="w-100 d-flex d-lg-none"
          /> -->

          <!-- <div class="col-12 z1 order-2 z1">
              <img
                src="../assets/imgs/playasol/linea-hor2.png"
                alt="linea"
                class="w-100 d-flex d-lg-none z1"
              />
            </div> -->

          <div
            class="col-lg-6 pr-4 pr-lg-5 order-1"
            data-aos=""
            :data-aos-delay="basedelay + 200"
          >
            <div class="row pasos text-center">
              <div class="col-12 px-2 px-lg-5">
                <div class="row pr-lg-5 py-5 pt-lg-5 mt-lg-4 nomargin">
                  <div class="col-12 py-3">
                    <div
                      class="row d-flex justify-content-center align-items-center"
                    >
                      <div
                        class="col-2 col-lg-2 text-right"
                        data-aos="fade-right"
                        :data-aos-delay="basedelay + 200"
                      >
                        <img
                          src="../assets/imgs/sorteocch/num1.png"
                          alt="paso 1"
                          class="img-fluid"
                        />
                      </div>
                      <div
                        class="col-10 col-lg-10 blanco text-left fG"
                        data-aos="fade-left"
                        :data-aos-delay="basedelay + 200"
                      >
                        <span class="blanco bold larger">Compra</span>&nbsp;
                        <span class="blanco"
                          >Cemento Chihuahua de 25kg o de 50kg.</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="col-12 py-3">
                    <div
                      class="row d-flex justify-content-center align-items-center"
                    >
                      <div
                        class="col-2 col-lg-2 text-right"
                        data-aos="fade-right"
                        :data-aos-delay="basedelay + 600"
                      >
                        <img
                          src="../assets/imgs/sorteocch/num2.png"
                          alt="paso 1"
                          class="img-fluid"
                        />
                      </div>
                      <div
                        class="col-10 col-lg-10 blanco text-left fG"
                        data-aos="fade-left"
                        :data-aos-delay="basedelay + 600"
                      >
                        <span class="blanco bold larger">Registra</span>&nbsp;
                        <span class="blanco"
                          >tu ticket de compra y por cada ticket registrado
                          obtén un boleto.</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="col-12 py-3 d-block d-lg-none">
                    <div
                      class="row d-flex justify-content-center align-items-center"
                    >
                      <div
                        class="col-4 col-lg-4 text-right relative z100"
                        data-aos="fade-right"
                        :data-aos-delay="basedelay + 400"
                      >
                        <img
                          src="../assets/imgs/sorteocch/saco-cafe.png"
                          alt="paso1"
                          class="costal z100"
                        />
                      </div>
                      <div class="col-8">
                        <div
                          class="row d-flex justify-content-center align-items-center"
                        >
                          <div
                            class="col-3 text-right"
                            data-aos="fade-right"
                            :data-aos-delay="basedelay + 1000"
                          >
                            <img
                              src="../assets/imgs/sorteocch/num3.png"
                              alt="paso 1"
                              class="img-fluid"
                            />
                          </div>
                          <div
                            class="col-9 blanco text-left fG"
                            data-aos="fade-left"
                            :data-aos-delay="basedelay + 1000"
                          >
                            <span class="blanco bold larger">Participa</span
                            >&nbsp;
                            <span class="blanco">en un sorteo de una </span>
                            <span class="amarillo bold"
                              >Nissan Frontier XE TM 2026.</span
                            >
                          </div>
                        </div>
                        <!-- <div class="row mt-3 ">
                          <div
                            class="col-12 boxanuncio"
                            data-aos="fade-right"
                            :data-aos-delay="basedelay + 1000"
                          >
                            <span class="blanco">
                              *Solo serán válidos los registros realizados
                              dentro de la vigencia del 06 de julio de 2026 al
                              13 de septiembre de 2026.
                            </span>
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-12 py-3 d-none d-lg-block">
                    <div
                      class="row d-flex justify-content-center align-items-center"
                    >
                      <div
                        class="col-2 col-lg-2 text-right"
                        data-aos="fade-right"
                        :data-aos-delay="basedelay + 1000"
                      >
                        <img
                          src="../assets/imgs/sorteocch/num3.png"
                          alt="paso 1"
                          class="img-fluid"
                        />
                      </div>
                      <div
                        class="col-10 col-lg-10 blanco text-left fG"
                        data-aos="fade-left"
                        :data-aos-delay="basedelay + 1000"
                      >
                        <span class="blanco bold larger">Participa</span>&nbsp;
                        <span class="blanco">en un sorteo de una </span>
                        <span class="amarillo bold"
                          >Nissan Frontier XE TM 2026.</span
                        >
                      </div>
                    </div>
                    <!-- <div class="row mt-3 ">
                      <div
                        class="col-12 boxanuncio"
                        data-aos="fade-right"
                        :data-aos-delay="basedelay + 1000"
                      >
                        <span class="blanco">
                          *Solo serán válidos los registros realizados dentro de
                          la vigencia del 06 de julio de 2026 al 13 de
                          septiembre de 2026.
                        </span>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="registro" class="px-5 px-lg-0 bg-white">
      <div
        class="pt-lg-5 container"
        data-aos="fade-up"
        :data-aos-delay="basedelay + 400"
      >
        <div class="row pt-5">
          <div id="inicia-sesion" class="col-lg-12 px-0 px-lg-5 pt-5 pt-lg-0">
            <div class="row">
              <!-- FIN PROMO 2026: se centra el login porque se ocultó el formulario de crear cuenta.
                   Para reactivar registro, volver a usar class="col-lg-6" aquí y mostrar la columna de signup. -->
              <div class="col-lg-6 offset-lg-3">
                <form @submit="login($event)" class="pb-5 r15">
                  <div class="col-12">
                    <p class="fG text-center azul pb-2">
                      Para comenzar <span class="">inicia sesión</span>:
                    </p>
                  </div>

                  <div class="col-12">
                    <div class="pb-5 row">
                      <div class="col-lg-12">
                        <span class="azul fG"> Correo electrónico </span>
                        <input
                          v-model.trim="loginForm.email"
                          type="email"
                          placeholder="Correo electrónico"
                          id="email1"
                          class="text-left"
                          required
                        />
                      </div>
                      <div class="col-lg-12">
                        <span class="azul fG"> Contraseña </span>
                        <input
                          v-model.trim="loginForm.password"
                          type="password"
                          placeholder="Contraseña"
                          id="password1"
                          class="text-left"
                          required
                        />
                      </div>
                      <div class="col-lg-6 offset-lg-6 text-right">
                        <div class="extras text-right underlined azul">
                          <a @click="togglePasswordReset()" class="pointer"
                            >Olvidé mi constraseña</a
                          >
                        </div>
                      </div>
                      <div
                        class="col-12 pt-5 px-2 text-center d-flex align-items-center"
                      >
                        <button
                          type="submit"
                          class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                        >
                          Entrar
                        </button>
                      </div>
                    </div>
                  </div>
                </form>

                <div class="row d-none d-lg-block">
                  <div class="col-12 pb-3 pt-5">
                    <div class="row">
                      <div
                        class="col-4 col-lg-4 text-right relative z100"
                        data-aos="fade-right"
                        :data-aos-delay="basedelay + 400"
                      >
                        <img
                          src="../assets/imgs/sorteocch/saco-cafe.png"
                          alt="paso1"
                          class="costal z100"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- FIN PROMO 2026: formulario de crear cuenta deshabilitado.
                   Para reutilizarlo más adelante, quitar v-if="false" y revertir el offset del login. -->
              <div class="col-lg-6" v-if="false">
                <div class="row">
                  <div class="col-12 z100">
                    <form @submit="signup($event)" class="pb-5 r15">
                      <div class="col-12">
                        <div class="row pb-4">
                          <div class="col-12">
                            <p class="fG text-center azul pb-2">
                              Si aún no tienes cuenta:
                            </p>
                          </div>
                          <div class="col-lg-12 pb-3">
                            <div class="fG azul">Nombre</div>
                            <input
                              v-model.trim="signupForm.nombre"
                              type="text"
                              placeholder="Nombre"
                              id="nombre"
                              required
                            />
                          </div>

                          <div class="col-lg-12 pb-3">
                            <div class="fG azul">Apellido Paterno</div>
                            <input
                              v-model.trim="signupForm.apellido"
                              type="text"
                              placeholder="Apellido Paterno"
                              id="apellido"
                              required
                            />
                          </div>

                          <div class="col-lg-12 pb-3">
                            <div class="fG azul">Apellido Materno</div>
                            <input
                              v-model.trim="signupForm.apellido2"
                              type="text"
                              placeholder="Apellido Materno"
                              id="apellido"
                              required
                            />
                          </div>

                          <div class="col-lg-12 pb-3">
                            <div class="fG azul">Correo electrónico</div>
                            <input
                              v-model.trim="signupForm.email"
                              type="email"
                              placeholder="Correo electrónico"
                              id="nombre"
                              required
                            />
                          </div>

                          <div class="col-lg-12 pb-3">
                            <div class="fG azul">Estado</div>
                            <select v-model="signupForm.estado" required>
                              <option value="" hidden>
                                Selecciona un estado
                              </option>
                              <option value="Aguascalientes">
                                Aguascalientes
                              </option>
                              <option value="Baja California">
                                Baja California
                              </option>
                              <option value="Baja California Sur">
                                Baja California Sur
                              </option>
                              <option value="Campeche">Campeche</option>
                              <option value="Chiapas">Chiapas</option>
                              <option value="Chihuahua">Chihuahua</option>
                              <option value="CDMX">Ciudad de México</option>
                              <option value="Coahuila">Coahuila</option>
                              <option value="Colima">Colima</option>
                              <option value="Durango">Durango</option>
                              <option value="Estado de México">
                                Estado de México
                              </option>
                              <option value="Guanajuato">Guanajuato</option>
                              <option value="Guerrero">Guerrero</option>
                              <option value="Hidalgo">Hidalgo</option>
                              <option value="Jalisco">Jalisco</option>
                              <option value="Michoacán">Michoacán</option>
                              <option value="Morelos">Morelos</option>
                              <option value="Nayarit">Nayarit</option>
                              <option value="Nuevo León">Nuevo León</option>
                              <option value="Oaxaca">Oaxaca</option>
                              <option value="Puebla">Puebla</option>
                              <option value="Querétaro">Querétaro</option>
                              <option value="Quintana Roo">Quintana Roo</option>
                              <option value="San Luis Potosí">
                                San Luis Potosí
                              </option>
                              <option value="Sinaloa">Sinaloa</option>
                              <option value="Sonora">Sonora</option>
                              <option value="Tabasco">Tabasco</option>
                              <option value="Tamaulipas">Tamaulipas</option>
                              <option value="Tlaxcala">Tlaxcala</option>
                              <option value="Veracruz">Veracruz</option>
                              <option value="Yucatán">Yucatán</option>
                              <option value="Zacatecas">Zacatecas</option>
                            </select>
                          </div>

                          <div class="col-lg-12 pb-3">
                            <div class="fG azul">
                              Municipio / Ciudad / Alcaldía
                            </div>
                            <input
                              v-model.trim="signupForm.ciudad_o_municipio"
                              type="text"
                              placeholder="Municipio / Ciudad / Alcaldía"
                              required
                            />
                          </div>

                          <div class="col-lg-12 pb-3">
                            <div class="fG azul">Colonia</div>
                            <input
                              v-model.trim="signupForm.colonia"
                              type="text"
                              placeholder="Colonia"
                              required
                            />
                          </div>

                          <div class="col-lg-12 pb-3">
                            <div class="fG azul">Calle</div>
                            <input
                              v-model.trim="signupForm.calle"
                              type="text"
                              placeholder="Calle"
                              required
                            />
                          </div>

                          <div class="col-lg-6 pb-3">
                            <div class="fG azul">Num. Exterior</div>
                            <input
                              v-model.trim="signupForm.num_ext"
                              type="text"
                              placeholder="Num. Exterior"
                              required
                            />
                          </div>

                          <div class="col-lg-6 pb-3">
                            <div class="fG azul">Num. Interior</div>
                            <input
                              v-model.trim="signupForm.num_int"
                              type="text"
                              placeholder="Num. Interior"
                            />
                          </div>

                          <div class="col-lg-6 pb-3">
                            <div class="fG azul">Código Postal</div>
                            <input
                              v-model.trim="signupForm.cp"
                              type="text"
                              placeholder="Código Postal"
                              id="cp"
                              required
                              pattern="\d{5}"
                              maxlength="5"
                              inputmode="numeric"
                              title="El código postal debe contener exactamente 5 dígitos"
                            />
                          </div>

                          <div class="col-lg-12 pb-3">
                            <div class="fG azul">Celular</div>
                            <input
                              v-model.trim="signupForm.celular"
                              type="text"
                              placeholder="Celular (10 dígitos)"
                              id="celular"
                              required
                              pattern="\d{10}"
                              maxlength="10"
                              inputmode="numeric"
                              title="El número celular debe contener exactamente 10 dígitos"
                            />
                          </div>
                          <div class="col-lg-12 pb-3">
                            <div class="fG azul">Contraseña</div>
                            <input
                              v-model.trim="signupForm.password"
                              type="password"
                              placeholder="Contraseña"
                              id="password2"
                              required
                            />
                          </div>

                          <div class="col-lg-12 pb-3">
                            <div class="fG azul">Fecha de nacimiento</div>
                            <input
                              v-model.trim="signupForm.fecha_nacimiento"
                              type="date"
                              @change="validateAge"
                              placeholder="Fecha de nacimiento"
                              id="fecha_nacimiento"
                              required
                            />
                          </div>

                          <div class="col-12 pb-0 text-center azul">
                            <label>
                              <input
                                type="checkbox"
                                v-model="signupForm.terminos"
                                required
                              />
                              He leído y acepto los
                              <router-link
                                class="underlined"
                                target="_blank"
                                to="/tycos-2026.pdf"
                                >términos y condiciones</router-link
                              >
                              y el

                              <a
                                href="https://www.gcc.com/"
                                class="underlined"
                                target="_blank"
                                rel="noopener noreferrer"
                                >aviso de privacidad</a
                              >.
                            </label>
                          </div>
                        </div>
                        <div class="row pb-0">
                          <div class="col-12 text-center">
                            <button
                              type="submit"
                              class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                            >
                              Registrarme
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <PasswordReset
      v-if="showPasswordReset"
      @close="togglePasswordReset()"
    ></PasswordReset>

    <Footer></Footer>
  </div>
</template>

<script>
import PasswordReset from "@/components/PasswordReset";
import MonederoSet from "@/components/MonederoSet";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

// import Parallax from "parallax-js";

import { mapState } from "vuex";

import mobile from "is-mobile";

export default {
  components: {
    PasswordReset,
    Footer,
  },
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        apellido2: "",
        estado: "",
        ciudad_o_municipio: "",
        colonia: "",
        calle: "",
        num_ext: "",
        num_int: "",
        cp: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        club_cinepolis: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      basedelay: 200,
      age: 0,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: true, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
      //disable: "mobile",
    });

    var scene = document.getElementById("scene");

    var vm = this;
    setTimeout(function () {
      vm.explotar = false;
      //var parallaxInstance = new Parallax(scene);
    }, 1000);

    //console.log({mobile: mobile()});
    if (mobile()) {
      this.basedelay = 400;
    }

  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      return Object.keys(this.userProfile).length > 1;
    },
  },
  methods: {
    validateAge() {
      if (this.signupForm.fecha_nacimiento) {
        const today = new Date();
        const birthDate = new Date(this.signupForm.fecha_nacimiento);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
        if (
          monthDifference < 0 ||
          (monthDifference === 0 && today.getDate() < birthDate.getDate())
        ) {
          age--;
        }
        this.age = age;
      } else {
        this.age = 0;
      }
    },
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      e.preventDefault();

      this.$store.dispatch("login", {
        email: this.loginForm.email,
        password: this.loginForm.password,
      });

      // // // const https = require("https");
      // // // var qData = {
      // // //   email: this.loginForm.email,
      // // // };
      // // // this.$http
      // // //   .post(
      // // //     process.env.VUE_APP_API_URL + "login.php",
      // // //     JSON.stringify(qData),
      // // //     {
      // // //       emulateJSON: true,
      // // //       httpsAgent: new https.Agent({ rejectUnauthorized: false }),
      // // //       headers: {
      // // //         "Content-Type": "text/plain",
      // // //         //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
      // // //       },
      // // //     }
      // // //   )
      // // //   .then(
      // // //     (response) => {
      // // //       // get body data
      // // //       console.log("envio mail");
      // // //       console.log(response);

      // // //       let res = response.body;

      // // //       if (res.status == "ok") {
      // // //         this.$store.dispatch("login", {
      // // //           email: this.loginForm.email,
      // // //           password: this.loginForm.password,
      // // //         });
      // // //       } else {
      // // //         swal.fire("Oops", res.msg, "warning");
      // // //       }
      // // //     },
      // // //     (error) => {
      // // //       // error callback
      // // //       console.log("error callback");
      // // //       console.log(error);
      // // //     }
      // // //   );
    },
    signup(e) {
      e.preventDefault();

      if (this.validPass(this.signupForm.password) === false) {
        swal.fire(
          "Oops",
          "La contraseña debe tener al menos 8 dígitos",
          "warning"
        );
        return false;
      }

      if (this.validPhone(this.signupForm.celular) === false) {
        swal.fire(
          "Oops",
          "El celular debe ser un número válido de 10 dígitos.",
          "warning"
        );
        return false;
      }

      if (this.age < 18) {
        swal.fire(
          "Oops",
          "Debes ser mayor de edad para participar en la promoción.",
          "warning"
        );
        return false;
      }

      this.registro();
    },
    async registro(monedero = "") {
      this.$store.dispatch("showLoader", true);

      console.log({ registro: this.signupForm });

      await this.enviaCorreo(
        this.signupForm.nombre,
        this.signupForm.apellido,
        this.signupForm.apellido2,
        this.signupForm.email,
        this.signupForm.celular,
        this.signupForm.fecha_nacimiento,
        this.signupForm.estado,
        this.signupForm.ciudad_o_municipio,
        this.signupForm.colonia,
        this.signupForm.calle,
        this.signupForm.num_ext,
        this.signupForm.num_int,
        this.signupForm.cp
      );

      // await this.$store.dispatch("signup", this.signupForm);
    },
    async enviaCorreo(
      nombre,
      apellido,
      apellido2,
      email,
      celular,
      fecha_nacimiento,
      estado,
      ciudad_o_municipio,
      colonia,
      calle,
      num_ext,
      num_int
    ) {
      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = {
        nombre: nombre,
        apellido: apellido,
        apellido2: apellido2,
        email: email,
        celular: celular,
        fecha_nacimiento: fecha_nacimiento,
        estado: estado,
        ciudad_o_municipio: ciudad_o_municipio,
        colonia: colonia,
        calle: calle,
        num_ext: num_ext,
        num_int: num_int,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro-prueba2.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            console.log("envio mail");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              const firebaseUser = await this.$store.dispatch(
                "signup",
                thes.signupForm
              );

              if (!firebaseUser) {
                return;
              }

              // thes.$gtag.event("conversion", {
              //   send_to: "AW-978746627/-5dyCPTN_-IBEIP62dID",
              // });

              //window.fbq("track", "CompleteRegistration");

              this.resetForm();
              this.toggleForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
              this.resetForm();
              this.toggleForm();
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            this.$store.dispatch("showLoader", false);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido: "",
        apellido2: "",
        estado: "",
        ciudad_o_municipio: "",
        colonia: "",
        calle: "",
        num_ext: "",
        num_int: "",
        cp: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        club_cinepolis: "",
        terminos: false,
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
  },
};
</script>
